/**
 * The composer: what you say to someone, in your own words (§14). Shown in
 * place of the choices while a conversation is open. The transcript it
 * feeds is discarded when the conversation ends; only the contract stays.
 */

import { useState } from 'react';

interface Props {
  readonly name: string;
  readonly busy: boolean;
  readonly onSend: (text: string) => void;
  readonly onLeave: () => void;
}

export function Talk({ name, busy, onSend, onLeave }: Props) {
  const [text, setText] = useState('');
  const ready = text.trim() !== '' && !busy;
  return (
    <form
      className="talk"
      onSubmit={(e) => {
        e.preventDefault();
        if (!ready) return;
        onSend(text.trim());
        setText('');
      }}
    >
      <input
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder={busy ? '…' : `Say something to ${name}`}
        disabled={busy}
        autoComplete="off"
        enterKeyHint="send"
        aria-label={`What you say to ${name}`}
      />
      <button type="submit" className="choice" disabled={!ready}>
        Say it
      </button>
      <button type="button" className="choice quiet" onClick={onLeave} disabled={busy}>
        Leave it there
      </button>
    </form>
  );
}
